import {SET_VISIBILITY_FILTER, RESET_VISIBILITY_FILTER,
        SET_SORT_KEY, RESET_SORT_KEY,
        SET_DIFFICULTY_FILTER, RESET_DIFFICULTY_FILTER,
        SET_TONALITY_FILTER, RESET_TONALITY_FILTER,
        SET_STATUS_FILTER, RESET_STATUS_FILTER,
        SET_TYPE_FILTER, RESET_TYPE_FILTER,
        SET_AUTHOR_FILTER, RESET_AUTHOR_FILTER, SET_AUTHOR_OPTIONS,
        SET_PERFORMER_FILTER, RESET_PERFORMER_FILTER, SET_PERFORMER_OPTIONS,
} from '../constants/filters';

const initialState = {
  visibilityFilter: '',
  difficultyFilter: 0,
  tonalityFilter: 0,
  statusFilter: 0,
  typeFilter: '',
  sortKey: 'id',
  sortOrders: {'id':-1, 'title':1, 'discount_price_number':1, 'discount':1, 'price':1},
  authorFilter: 0,
  authorOptions: [],
  performerFilter: null,
  performerOptions: []
};

const filtersReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VISIBILITY_FILTER:
      return {
        ...state,
        visibilityFilter: action.filter
      };
    case RESET_VISIBILITY_FILTER:
      return {
        ...state,
        visibilityFilter: ''
      };
    case SET_SORT_KEY:
      return {
        ...state,
        sortKey: action.key,
        sortOrders: {...state.sortOrders, [action.key]: state.sortOrders[action.key] * -1},
      };
    case RESET_SORT_KEY:
      return {
        ...state,
        sortKey: 'id',
        sortOrders: {'id':-1, 'title':1, 'discount_price_number':1, 'discount':1, 'price':1},
      };
    case SET_DIFFICULTY_FILTER:
      return {
        ...state,
        difficultyFilter: action.filter
      };
    case RESET_DIFFICULTY_FILTER:
      return {
        ...state,
        difficultyFilter: 0
      };
    case SET_TONALITY_FILTER:
      return {
        ...state,
        tonalityFilter: action.filter
      };
    case RESET_TONALITY_FILTER:
      return {
        ...state,
        tonalityFilter: 0
      };
    case SET_STATUS_FILTER:
      return {
        ...state,
        statusFilter: action.filter
      };
    case RESET_STATUS_FILTER:
      return {
        ...state,
        statusFilter: 0
      };
    case SET_TYPE_FILTER:
      return {
        ...state,
        typeFilter: action.filter
      };
    case RESET_TYPE_FILTER:
      return {
        ...state,
        typeFilter: ''
      };
    case SET_AUTHOR_FILTER:
      return {
        ...state,
        authorFilter: action.filter,
      };
    case SET_AUTHOR_OPTIONS:
      return {
        ...state,
        authorOptions: action.list,
      };
    case RESET_AUTHOR_FILTER:
      return {
        ...state,
        authorFilter: 0,
        authorOptions: []
      };
    case SET_PERFORMER_FILTER:
      return {
        ...state,
        performerFilter: action.filter,
      };
    case SET_PERFORMER_OPTIONS:
      return {
        ...state,
        performerOptions: action.list,
      };
    case RESET_PERFORMER_FILTER:
      return {
        ...state,
        performerFilter: null,
        performerOptions: []
      };

    default:
      return state;
  }
};

export default filtersReducer;